import { render } from "./404.vue?vue&type=template&id=1ffed138"
const script = {}
script.render = render

export default script